import type { UpdateTracexIntegrationBody } from '@ditto/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthenticatedClient, useProtectedQuery } from './useApi';

export const useGetTracexIntegrationApi = () => {
  const { client } = useAuthenticatedClient();
  return useProtectedQuery({
    queryKey: ['tracex-integration'],
    queryFn: async () => {
      const response = await client.integration.getTracexIntegration();
      if (response.status === 200) return response.body;
      throw new Error('Failed to fetch TraceX integration');
    },
  });
};

export const useUpdateTracexIntegrationApi = () => {
  const { client } = useAuthenticatedClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: UpdateTracexIntegrationBody) => {
      const response = await client.integration.updateTracexIntegration({
        body,
      });
      if (response.status === 200) return response.body;
      throw new Error('Failed to update TraceX integration');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tracex-integration'] });
    },
  });
};
